import _ from 'lodash/lodash';

const config = {
  namespaced: true,
  state: {
    config: null,
  },
  getters: {
    getConfigByKey: (state, getters, rootState, rootGetters) => (key, fallback) => {
      const contract = rootGetters['contracts/selected'];
      const config = contract ? contract.config : null;
      if ( ! config) return;
      // Using lodash's get to support dot notation paths.
      // return config[key];
      return _.get(config, key, fallback);
    },
    getTerminology: (state, getters) => (path, fallback) => {
      // Using lodash's get to support dot notation paths.
      fallback = (_.isString(fallback)) ? fallback : "";
      return _.get(getters.getConfigByKey("terminologies"), path, fallback);
    },
  },
  mutations: {
    setConfig(state, contract) {
      if (contract && contract.config && typeof contract.config === 'object') {
        // previously expected a data node since the "config" object
        // was actually a firm object with config nested as "data".
        contract.data = Object.assign({}, contract.config);
      }
      state.config = contract;
    },
  },
  actions: {
    async fetchConfig({ commit, state, dispatch, getters }) {
      const contract = await new Promise((resolve, reject) => {
        const selected = getters['contracts/selected'] || null;
        return resolve(selected);
      });
      commit('setConfig', contract);
    },
  },
};

export default config;
